/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigiticketsEvent
 */
export interface DigiticketsEvent {
    /**
     * 
     * @type {number}
     * @memberof DigiticketsEvent
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DigiticketsEvent
     */
    name: string;
}

/**
 * Check if a given object implements the DigiticketsEvent interface.
 */
export function instanceOfDigiticketsEvent(value: object): value is DigiticketsEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DigiticketsEventFromJSON(json: any): DigiticketsEvent {
    return DigiticketsEventFromJSONTyped(json, false);
}

export function DigiticketsEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigiticketsEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

  export function DigiticketsEventToJSON(json: any): DigiticketsEvent {
      return DigiticketsEventToJSONTyped(json, false);
  }

  export function DigiticketsEventToJSONTyped(value?: DigiticketsEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

